<template>
  <div class="flex flex-col gap-y-[16px]">
    <UICheckbox
      label="Trigger on enter"
      size="medium"
      ref="triggersEnter"
      v-model="triggersDataEnter"
    />
    <UICheckbox
      label="Trigger on exit"
      size="medium"
      ref="triggersExit"
      v-model="triggersDataExit"
    />
  </div>
  <div class="flex flex-col gap-y-[24px]">
    <UICombobox
      label="Geofence"
      placeholder="Enter geofence name"
      ref="geofenceSelect"
      :options="items"
      :open-on-focus="true"
      v-model="selectedAddress"
    />
    <!-- <div class="h-[320px]" /> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'GeofenceField',
  emits: ['onChange'],
  props: {
    triggers: {
      type: [Array],
      required: true,
    },
    address: {
      type: [Number],
      required: true,
    },
  },
  data() {
    return {
      selectedAddress: {},
    };
  },
  computed: {
    ...mapGetters({
      geofences: 'geofence/all',
    }),
    triggersDataEnter: {
        get() {
          return this.triggers?.includes('enter')
        },
        set(value) {
          this.emitChanges(value, this.triggersDataExit)
        }
    },
    triggersDataExit: {
      get() {
        return this.triggers?.includes('exit')
      },
      set(value) {
        this.emitChanges(this.triggersDataEnter, value)
      }
    },
    items() {
      return this.geofences.map((geofence) => ({
        label: geofence.name,
        value: geofence.id,
      }));
    },
  },
  mounted() {
    if (this.address) {
      this.$nextTick(() => {
        this.populateGeofenceSelect();
      });
    }
  },
  watch: {
    triggers: {
      deep: true,
      handler() {
        if (this.triggers?.length) {
          this.$refs.triggersEnter.setCheckQuietly(
            this.triggers?.includes('enter'),
          );
          this.$refs.triggersExit.setCheckQuietly(
            this.triggers?.includes('exit')
          );
        }
      },
    },
    selectedAddress() {
      this.emitChanges(this.triggersDataEnter, this.triggersDataExit)
    },
    items: {
      handler() {
        this.populateGeofenceSelect();
      },
    },
  },
  methods: {
    populateGeofenceSelect() {
      if (!this.items?.length) {
        return;
      }
      const item = this.items.find(
        (geofence) => geofence.value === this.address,
      );

      if (!item) {
        return;
      }

      this.$refs.geofenceSelect?.setSelectedOptionQueitly(item);
    },
    emitChanges(enter, exit) {
      const triggers = [];
      if (enter) {
        triggers.push('enter');
      }
      if (exit) {
        triggers.push('exit');
      }
      this.$emit('onChange', {
        triggers,
        address: this.selectedAddress?.value,
      });
    },
  },
};
</script>
